import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import history from 'logic/history';
import { MuiThemeProvider } from '@material-ui/core';
import 'react-phone-number-input/style.css';
import Snackbar from 'components/shared/Snackbar';
import Index from './routes';
import IntlProvider from './i18n/IntlProvider';
import store from './store';
import theme from './theme';
import './styles/main.scss';

if (!Object.values) {
  Object.values = (obj) => Object.keys(obj).map((key) => obj[key]);
}

if (process.env.NODE_ENV === 'production' && !process.env.REACT_APP_SENTRY_URL) {
  throw new Error('Missing REACT_APP_SENTRY_URL');
}

if (!process.env.REACT_APP_CORE_ID_URL) {
  throw new Error('Missing CoreID URL');
}

if (!process.env.REACT_APP_STRIPE_API_KEY) {
  throw new Error('Missing REACT_APP_STRIPE_API_KEY');
}

if (!process.env.REACT_APP_GMAP_KEY) {
  throw new Error('Missing REACT_APP_GMAP_KEY');
}

Sentry.init({ dsn: process.env.REACT_APP_SENTRY_URL });

const RouterInstance = () => (
  <Provider store={store}>
    <IntlProvider>
      <Router history={history}>
        <MuiThemeProvider theme={theme}>
          <Index />
          <Snackbar />
        </MuiThemeProvider>
      </Router>
    </IntlProvider>
  </Provider>
);

render(<RouterInstance />, document.getElementById('root'));
